var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkl-pencil-textarea" },
    [
      _c(
        "PencilEdit",
        {
          ref: "modal",
          attrs: { canEdit: _vm.canEdit },
          on: { open: _vm.onOpen, close: _vm.onClose },
        },
        [
          _c("HKLTextarea", {
            directives: [{ name: "focus", rawName: "v-focus" }],
            model: {
              value: _vm.inputData,
              callback: function ($$v) {
                _vm.inputData = $$v
              },
              expression: "inputData",
            },
          }),
          _vm._v(" "),
          _c(
            "pre",
            {
              staticClass: "field__display",
              class: _vm.displayTextClass,
              attrs: { slot: "display-show" },
              on: {
                dblclick: function () {
                  return _vm.onDoubleClick()
                },
              },
              slot: "display-show",
            },
            [_vm._v(_vm._s(_vm.displayText))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }